import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
import { useKeycloak } from "@react-keycloak/web";
import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { translate } from "react-switch-lang";
import { Button, Dropdown, DropdownItem, DropdownMenu, Media, Progress, Row } from "reactstrap";
import { default as Swal, default as SweetAlert } from "sweetalert2";
import { DisplayMode } from "../../../models/displayModeDto";
import { TrainingPathDto } from "../../../models/trainingPathDto";
import { TrainingPathTanslationDto } from "../../../models/trainingPathTranslationDto";
import hasRoles from "../../../security/hasRoles";
import { useHttpClient } from "../../../security/hooks/axiosProvider";
import { RootState } from "../../../store";
import "./trainingPath.scss";



const TrainingPath: React.FC<{
  tabId?: string;
  trainingPath?: TrainingPathDto;
  displayMode?: DisplayMode;
  deleteTrainingPath?;
  changeStatus?;
  archiveTrainingPath?: any;
  archived?: Boolean;
  cloneTrainingPath?: any;
  t: (key: string) => string;
}> = props => {
  const keycloak = useKeycloak().keycloak;
  const httpClient = useHttpClient(keycloak.authenticated);
  const [nbModule, setNbModule] = useState(0);
  const [nbLanguage, setNbLanguage] = useState(1);
  const history = useHistory();
  const [trainingTranslation, setTrainingTranslation] = useState<TrainingPathTanslationDto>(new TrainingPathTanslationDto());
  const hasRoleAdmin = hasRoles(["ROLE_ELEARNING_ADMIN"], keycloak);
  const hasRoleUser = hasRoles(["ROLE_ELEARNING_USER"], keycloak);
  const currentLang = useSelector((state: RootState) => state.language.currentLang);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isModulesFinishied, setIsModulesFinishied] = useState(false);
  const toggle = () => setDropdownOpen(prevState => !prevState);
  const [moduleFinishedPourcentage, setModuleFinishedPourcentage] = useState(0);
  const [isUsers, setIsUsers] = useState(false);

  function confirmationAlert(title: string, confirmButtonText: any, iconType: any) {
    return SweetAlert.fire({
      title: title,
      cancelButtonText: props.t("cancel"),
      confirmButtonText: confirmButtonText,
      confirmButtonColor: "#FF0000",
      reverseButtons: true,
      showCancelButton: true,
      icon: iconType,
      width: window.outerWidth <= 600 ? "90%" : "",
    });
  }

  const handelImageClick = () => {
    if (!keycloak.authenticated) {
      history.push(`/overview/${props.trainingPath.id}`);
    }
    if (hasRoleAdmin) {
      history.push(`/training-paths/manage-overview/${trainingTranslation?.id}`);
    }
    if (hasRoleUser && isUsers) {
      httpClient.current?.get(`/trainingPath/isAlreadyStarted/${props.trainingPath.id}`).then(response => {
        if (!response.data) {
          httpClient.current?.post(`/trainingPath/startTrainingPath/${props.trainingPath.id}`);
        }
        history.push(`/training-paths/starting-modules/${props.trainingPath.id}`);
      });
    }
    if (hasRoleUser && !isUsers) {
      history.push(`/overview/${props.trainingPath.id}`);
    }
  };

  useEffect(() => {
    getTrainingPathTranslation();
    // eslint-disable-next-line
  }, [currentLang]);

  useEffect(() => {
    async function fetchTrainingPath() {
      getTrainingPathTranslation();
    }
    fetchTrainingPath();
    // eslint-disable-next-line
  }, []);

  async function getTrainingPathTranslation() {
    if (props?.trainingPath) {
      const response = await httpClient.current?.get(`/trainingPathTranslation/trainingPath/${props?.trainingPath?.id}`);
      setNbLanguage(response.data.length);
      let result = (response.data as TrainingPathTanslationDto[]).filter(training => training.language === currentLang.toUpperCase());
      setTrainingTranslation(result[0]);
      setNbModule(result[0]?.moduleList.length);
      if (!hasRoleAdmin) {
        let finishedModuleNumber = 0;
        result[0]?.moduleList?.forEach(async module => {
          const response = await httpClient.current.get(`/course/isModuleFinished/${module.id}`);
          if (response.data === true) finishedModuleNumber++;
          setIsModulesFinishied(finishedModuleNumber === result[0].moduleList.length);
          setModuleFinishedPourcentage(Math.floor((finishedModuleNumber / result[0].moduleList.length) * 100));
        });
        const responseData = await httpClient.current?.get(`/trainingPath/byUser`, { params: { language: currentLang.toUpperCase(), archived: false } });
        setIsUsers((responseData?.data.content as TrainingPathDto[])?.some(trainingPath => props.trainingPath.id === trainingPath.id));
      }
    }
  }

  const handleChange = () => {
    props.changeStatus(props.trainingPath);
  };

  const archive = () => {
    props.archiveTrainingPath(props.trainingPath);
  };

  const handlArchive = () => {
    confirmationAlert("Êtes-vous sûr que vous voulez archiver ce parcours?", props.t("archive"), "warning").then(result => {
      if (result.isConfirmed) {
        archive();
        Swal.fire("Parcours Bien Archivé!", "", "success");
      }
    });
  };

  const handlManageOverview = (trainingTranslationID: number) => {
    history.push(`/training-paths/manage-overview/${trainingTranslationID}`);
  };

  const handlUpdate = () => {
    history.push(`/training-paths/update/${props.trainingPath.id}`);
  };

  const handleClone = () => {
    httpClient.current?.post(`trainingPath/duplicate?trainingPathId=${props.trainingPath.id}`).then(() => props.cloneTrainingPath());
  };

  const displayLanguageFlag = (): JSX.Element => {
    if (nbLanguage === 2) {
      return (
        <span>
          <i id="tableIconBtn" className="trainingpath-flag-icon flag-icon flag-icon-fr"></i>
          <i className="trainingpath-flag-icon flag-icon flag-icon-gb"></i>
        </span>
      );
    } else if (trainingTranslation?.language === "FR") {
      return (
        <span>
          <i className="trainingpath-flag-icon flag-icon flag-icon-fr"></i>
        </span>
      );
    } else if (trainingTranslation?.language === "EN") {
      return (
        <span>
          <i className="trainingpath-flag-icon flag-icon flag-icon-gb"></i>
        </span>
      );
    } else {
      return <span>ops! something wrong!</span>;
    }
  };

  return (
    <>
      {DisplayMode.LIST === props.displayMode ? (
        <tr className="training-table">
          <td className="cursor-pointer" onClick={() => history.push(`${keycloak.authenticated && hasRoleAdmin ? "/training-paths/" : "/"}overview/${props.trainingPath.id}`)}>
            {trainingTranslation?.title}
          </td>
          <td align="center">{nbModule}</td>
          <td align="center">{trainingTranslation?.trainingPathDuration}</td>
          {!props.archived && (
            <td align="center">
              <Form.Check
                className="training-card__actions__btn-switch"
                id={props.trainingPath.id.toString()}
                defaultChecked={props.trainingPath.status !== undefined ? props.trainingPath.status : false}
                onChange={() => handleChange()}
                type="switch"
              />
            </td>
          )}
          <td className="action-col">
            <Row className="dropdown-basic">
              {!props.archived ? (
                <Dropdown className="dropdown" isOpen={dropdownOpen} toggle={toggle}>
                  <div className="btn-group">
                    <Button style={{ display: "flex", justifyContent: "center" }} color="link" outline>
                      &emsp;&emsp;&emsp;&emsp;<i className={"iconMenu fa fa-ellipsis-v align-middle"}></i>&emsp;&emsp;&emsp;
                    </Button>
                    <DropdownMenu className="dropdown-content">
                      <span
                        className="d-inline-block"
                        tabIndex={0}
                        data-toggle="tooltip"
                        title={props.trainingPath.status ? "Veuillez désactiver le parcours" : "Parametrer les informations du parcours"}
                      >
                        <DropdownItem disabled={props.trainingPath.status} onClick={() => handlManageOverview(trainingTranslation?.id)}>
                          <span>
                            <i id="tableIconBtn" className="fa fa-file training-card__actions__btn-update"></i> {props.t("user_view")}
                          </span>
                        </DropdownItem>
                      </span>
                      <span
                        className="d-inline-block"
                        tabIndex={0}
                        data-toggle="tooltip"
                        title={props.trainingPath.status ? "Veuillez désactiver le parcours" : "Modifier les informations du parcours"}
                      >
                        <DropdownItem disabled={props.trainingPath.status && nbLanguage === 2} onClick={() => handlUpdate()}>
                          <span>
                            <i id="tableIconBtn" className="fa fa-edit training-card__actions__btn-update"></i>
                            Modifier
                          </span>
                        </DropdownItem>
                      </span>
                      <span className="d-inline-block" tabIndex={0} data-toggle="tooltip" title={props.trainingPath.status ? "Veuillez désactiver le parcours" : props.t("archive_course")}>
                        <DropdownItem onClick={() => handleClone()}>
                          <span>
                            <i id="tableIconBtn" className="fa fa-copy"></i>
                            {props.t("clone")}
                          </span>
                        </DropdownItem>
                      </span>
                      <span className="d-inline-block" tabIndex={0} data-toggle="tooltip" title={props.trainingPath.status ? "Veuillez désactiver le parcours" : props.t("archive_course")}>
                        <DropdownItem disabled={props.trainingPath.status} onClick={() => handlArchive()}>
                          <span>
                            <i id="tableIconBtn" className="fa fa-archive training-card__actions__btn-delete"></i>
                            Archiver
                          </span>
                        </DropdownItem>
                      </span>
                    </DropdownMenu>
                  </div>
                </Dropdown>
              ) : (
                <>
                  <span>
                    <i
                      id="tableIconBtn"
                      onClick={() => {
                        confirmationAlert("Êtes-vous sûr que vous voulez supprimer ce parcours?", "Supprimer !", "warning").then(result => {
                          if (result.isConfirmed) {
                            props.deleteTrainingPath(props?.trainingPath?.id);
                            Swal.fire("Parcours Bien Supprimé!!", "", "success");
                          }
                        });
                      }}
                      title="Supprimer le parcours"
                      className="fa fa-trash training-card__actions__btn-delete"
                    ></i>
                  </span>
                  <span>
                    <i
                      id="tableIconBtn"
                      onClick={() => {
                        confirmationAlert("Êtes-vous sûr que vous voulez restaurer ce parcours?", "Restaurer !", "warning").then(result => {
                          if (result.isConfirmed) {
                            props.archiveTrainingPath(props?.trainingPath);
                            Swal.fire("Parcours Bien Restauré!!", "", "success");
                          }
                        });
                      }}
                      title="Restaurer le parcours"
                      className="fa fa-archive training-card__actions__btn-delete"
                    ></i>
                  </span>
                </>
              )}
            </Row>
          </td>
        </tr>
      ) : (
        <div className="training-card" key={props?.trainingPath.id}>
          <div className="training-card__image-cover" onClick={handelImageClick}>
            <Media body className="training-card__image-cover__image" src={props.trainingPath.imageUrl} alt="image-cover" />
          </div>

          {hasRoleAdmin && keycloak.authenticated && (
            <div className="training-card__status">
              <span className={`badge ${props.trainingPath.status ? "badge-success" : "badge-danger"}`}>{props.trainingPath.status ? "Disponible" : "Inactif"}</span>
            </div>
          )}

          {!hasRoleAdmin && keycloak.authenticated && isUsers && (
            <div className="training-card__status">
              <span className={`badge ${isModulesFinishied ? "badge-success" : "badge-danger"}`}>{isModulesFinishied ? props.t("finished") : "En cours"}</span>
            </div>
          )}
          <div className="training-card__title">{trainingTranslation?.title}</div>
          <div className="training-card__language">{displayLanguageFlag()}</div>

          {hasRoleUser && (
            <div className="training-card__progress_wrapper">
              <Progress color="success" className="training-card__progress" value={moduleFinishedPourcentage} />
              <span>{moduleFinishedPourcentage + "%"}</span>
            </div>
          )}
          <div className="training-card__actions">
            <Button className={hasRoleAdmin ? "training-card__actions__btn-more_admin" : "training-card__actions__btn-more"} outline color="light" onClick={handelImageClick}>
              {keycloak.authenticated && hasRoleAdmin ? props.t("user_view") :  keycloak.authenticated && !hasRoleAdmin && props.tabId === "1" ? props.t("start_course") : keycloak.authenticated && !hasRoleAdmin ? props.t("access_the_course") : props.t("learn_more")}
            </Button>
            {hasRoleAdmin && (
              <>
                <Form.Check
                  className="training-card__actions__btn-switch"
                  id={props.trainingPath.id.toString()}
                  defaultChecked={props.trainingPath.status !== undefined ? props.trainingPath.status : false}
                  onChange={() => handleChange()}
                  type="switch"
                />
                <span className="d-inline-block" tabIndex={0} data-toggle="tooltip" title={props.trainingPath.status ? "Veuillez désactiver le parcours" : "Modifier les informations du parcours"}>
                  <Button color="link" style={{ padding: "5px", margin: "0px" }} onClick={() => handlUpdate()} disabled={props.trainingPath.status}>
                    <i className="fa fa-edit training-card__actions__btn-update"></i>
                  </Button>
                </span>
                <span className="d-inline-block" tabIndex={0} data-toggle="tooltip" title={props.trainingPath.status ? "Veuillez désactiver le parcours" : props.t("archive_course")}>
                  <Button color="link" style={{ padding: "5px", margin: "0px", justifyContent: "center" }} onClick={() => handlArchive()} disabled={props.trainingPath.status}>
                    <i className="fa fa-archive training-card__actions__btn-delete"></i>
                  </Button>
                </span>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default translate(TrainingPath);
